// extracted by mini-css-extract-plugin
export var sectioncalc = "newCalculator-module--sectioncalc--xDlDn";
export var darkColor = "newCalculator-module--darkColor--R2lSR";
export var descr = "newCalculator-module--descr--IeJpf";
export var block_header = "newCalculator-module--block_header--f9rpB";
export var block_bottom = "newCalculator-module--block_bottom--KKGwx";
export var title = "newCalculator-module--title--PT+OI";
export var offer = "newCalculator-module--offer--ubRCI";
export var calcHeader = "newCalculator-module--calcHeader--QfbNm";
export var head = "newCalculator-module--head--XcKCX";
export var anotherDescr = "newCalculator-module--anotherDescr--x-7iS";
export var content = "newCalculator-module--content--x+3Ef";
export var sliderContainer = "newCalculator-module--sliderContainer---LuIJ";
export var sliderDescr = "newCalculator-module--sliderDescr--QZNsQ";
export var sliderSum = "newCalculator-module--sliderSum--PGZsY";
export var slider = "newCalculator-module--slider--oSU52";
export var track = "newCalculator-module--track--Q8ei+";
export var rail = "newCalculator-module--rail--QlNXy";
export var thumb = "newCalculator-module--thumb--AWwg+";
export var card = "newCalculator-module--card--LrO8L";
export var cardHeader = "newCalculator-module--cardHeader--FH9DS";
export var cardHead = "newCalculator-module--cardHead--Soq2M";
export var sum = "newCalculator-module--sum--8Va6i";
export var btn = "newCalculator-module--btn--rnsKq";
export var hintContainer = "newCalculator-module--hintContainer--jRZep";
export var close = "newCalculator-module--close--8DsJ9";
export var hintModal = "newCalculator-module--hintModal--kbKhb";
export var hintModalQuestion = "newCalculator-module--hintModalQuestion--f4mKf";
export var checkboxContainer = "newCalculator-module--checkboxContainer--Zv1H0";
export var tooltip = "newCalculator-module--tooltip--cp5z1";
export var errorText = "newCalculator-module--errorText--s66Ri";